import { useCallback } from 'react';

import { AgGridReact } from 'ag-grid-react';

type UseGridSelectionProps<T> = {
  gridRef: React.RefObject<AgGridReact> | null;
  onSelectionChange: (selected: T[]) => void;
  mode?: 'single' | 'multiple';
};

export const useGridSelection = <T>({
  gridRef,
  onSelectionChange,
  mode = 'multiple',
}: UseGridSelectionProps<T>) => {
  const handleSelectionChanged = useCallback(() => {
    const selectedRows = gridRef?.current?.api?.getSelectedRows() as
      | T[]
      | undefined;

    if (selectedRows && selectedRows.length > 0) {
      if (mode === 'single') {
        onSelectionChange([selectedRows[0]]);
      } else {
        onSelectionChange(selectedRows);
      }
    } else {
      onSelectionChange([]);
    }
  }, [gridRef, onSelectionChange, mode]);

  return { handleSelectionChanged };
};
